<div class="fn-account-transactions__container">
  <div class="fn-account-transactions__container-table">
    <app-fn-tables
      [optionalTitle]="'IP.TABLE.ACCOUNT-TRANSACTIONS.TITLE'"
      [tableOption]="tableOptions"
      [propertyOrder]="propertyOrder"
      (action)="onAction($event)"
      [pageItems]="10"
      [filter]="false"
      [supplierId]="this.selectedSupplierId"
      service="account-transactions"
    />
  </div>
</div>
